var moment = module.exports = require("./moment-timezone");
moment.tz.load(require('./data/packed/latest.json'));



//////////////////
// WEBPACK FOOTER
// /data/www/SGDBackend-Nex2/~/moment-timezone/index.js
// module id = 599
// module chunks = 0